import { UserRole } from '../types';

export const ADMIN_ROLES: UserRole[] = ['owner', 'admin'];

export const normalizeUserRole = (value: unknown): UserRole => {
  if (value === 'owner' || value === 'admin' || value === 'viewer') return value;
  if (value === 'officer') return 'viewer';
  return 'viewer';
};

export const isAdminRole = (role: UserRole) => ADMIN_ROLES.includes(role);

export const roleLabel = (role: UserRole) => {
  if (role === 'owner') return 'Owner';
  if (role === 'admin') return 'Admin';
  return 'Viewer';
};
